/**
 * 波A · 长图模板「套用」的 history state 单源(B3)。
 *
 * 模板库页与舱内弹层两个入口都从这里拼 —— 搭建器唯一验型器只认这一个形状
 * (`LongImageBuilderPage` 的 `posterTemplate` 分支),两边各拼一份迟早漂移。
 * schema 在这里**不验型**:验型是消费侧(唯一验型器)的职责,发起侧只搬运。
 */
import type { PosterTemplateBrief } from "../../api/posterTemplateService";

export interface PosterTemplateHandoffState {
  posterTemplate: {
    schema: unknown;
    templateId: number;
    templateName: string;
    coverUrl: string | null;
  };
}

export function templateHandoffState(t: PosterTemplateBrief): PosterTemplateHandoffState {
  return {
    posterTemplate: {
      schema: t.schemaJson,
      templateId: t.id,
      templateName: t.name,
      coverUrl: t.thumbUrl ?? t.coverImageUrl ?? null,
    },
  };
}
